import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaHome, FaHandHoldingHeart, FaNewspaper, FaUsers, FaUser } from "react-icons/fa";

const menus = [
  { label: "Donasi", icon: FaHandHoldingHeart, path: "/donasi" },
  { label: "Berita", icon: FaNewspaper, path: "/berita" },
  { label: "Home", icon: FaHome, path: "/" },
  { label: "Relawan", icon: FaUsers, path: "/relawan" },
  { label: "Daftar", icon: FaUser, path: "https://patunganindonesia.online/login/inspirator" },
];

const BottomNavbar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {/* ================= MOBILE ================= */}
      <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
        <div className=" bg-white/90 backdrop-blur  shadow-xl px-4 py-3 flex justify-between items-center">
          {menus.map((item, i) => {
            const Icon = item.icon;
            const active = isActive(item.path);

            // middle button
            if (i === 2) {
              return (
                <NavLink key={item.label} to={item.path} className="relative -mt-10">
                  <div
                    className="
                    w-16 h-16 rounded-full bg-primary2 text-white
                    flex items-center justify-center
                    border-4 border-white
                    shadow-[0_0_22px_rgba(41,171,226,0.8)]
                    hover:shadow-[0_0_32px_rgba(41,171,226,1)]
                    transition-all duration-300
                  ">
                    <Icon size={22} />
                  </div>
                </NavLink>
              );
            }

            return (
              <NavLink key={item.label} to={item.path} className="flex flex-col items-center text-xs">
                <Icon size={18} className={active ? "text-primary2" : "text-gray-400"} />
                <span className={active ? "text-primary2 font-semibold" : "text-gray-400"}>{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>

      {/* ================= DESKTOP FLOAT ================= */}
      <div className="hidden md:block fixed bottom-6 right-6 z-50">
        {/* menu items */}
        {open && (
          <div className="mb-3 flex flex-col items-end gap-3 w-full bg-primary2 p-4 rounded-lg">
            {menus.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.path);

              return (
                <div className="flex items-center gap-3 bg-white shadow-lg px-4 py-2 rounded-full hover:shadow-xl transition w-full">
                  <NavLink key={item.label} to={item.path} className="flex gap-3  items-center">
                    <Icon size={18} className={active ? "text-primary2" : "text-gray-500"} />
                    <span className={active ? "text-primary2 font-semibold text-sm" : "text-gray-600 text-sm"}>{item.label}</span>
                  </NavLink>
                </div>
              );
            })}
          </div>
        )}

        {/* floating button */}
        <button
          onClick={() => setOpen(!open)}
          className="
    w-14 h-14 rounded-full bg-primary2 text-white
    flex items-center justify-center
    shadow-[0_0_20px_rgba(41,171,226,0.75)]
    hover:shadow-[0_0_30px_rgba(41,171,226,1)]
    hover:scale-105
    transition-all duration-300
  ">
          <FaHome size={20} />
        </button>
      </div>
    </>
  );
};

export default BottomNavbar;
